import React, { useEffect, useState } from 'react'
import Sells from '../Sells/Sells'
import axios from 'axios'
import Loading from '../../components/Display/Loading'

const server = process.env.REACT_APP_SERVER_URL

interface ISubscriptionInvoiceData {
  client: any
  subscription: any
  items: any[]
}

const InvoiceSubscription: React.FC = () => {
  const [render, setRender] = useState(false)
  const [subscriptionData, setSubscriptionData] = useState<ISubscriptionInvoiceData | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [notFound, setNotFound] = useState<boolean>(false)
  const [discountFromUrl, setDiscountFromUrl] = useState<number | null>(null)

  const onGetSubscriptionData = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search)
      const clientId = urlParams.get('clientId')
      const subscriptionId = urlParams.get('subscriptionId')
      const discount = urlParams.get('discount')

      console.log('InvoiceSubscription - clientId:', clientId)
      console.log('InvoiceSubscription - subscriptionId:', subscriptionId)
      console.log('InvoiceSubscription - discount:', discount)

      if (!clientId || !subscriptionId) {
        console.log('InvoiceSubscription - Missing clientId or subscriptionId')
        setNotFound(true)
        return
      }

      setIsLoading(true)

      console.log('InvoiceSubscription - Fetching client and subscription...')

      // Obtener datos del cliente y suscripción
      const [clientResponse, subscriptionResponse] = await Promise.all([
        axios.get(`${server}/thirdparty/client?id=${clientId}`),
        axios.get(`${server}/subscription?id=${subscriptionId}`)
      ])

      console.log('InvoiceSubscription - clientResponse:', clientResponse.data)
      console.log('InvoiceSubscription - subscriptionResponse:', subscriptionResponse.data)

      const client = clientResponse.data.client
      const subscription = subscriptionResponse.data.subscription

      console.log('InvoiceSubscription - subscription.items:', subscription.items)

      // Mapear los items de la suscripción
      const itemsPromises = subscription.items.map(async (item: any) => {
        console.log('InvoiceSubscription - processing item:', item)

        if (item.type === 'product') {
          console.log('InvoiceSubscription - fetching product from /inventory/item with id:', item.id)
          const itemResponse = await axios.get(`${server}/inventory/item?id=${item.id}`)
          console.log('InvoiceSubscription - product response:', itemResponse.data)

          return {
            ...itemResponse.data.item,
            amount: item.amount,
            // Usar el type que viene del backend (ej: "MERCHANDISE")
            type: itemResponse.data.item.type,
          }
        } else {
          console.log('InvoiceSubscription - fetching service from /service with id:', item.id)
          const serviceResponse = await axios.get(`${server}/service?id=${item.id}`)
          console.log('InvoiceSubscription - service response:', serviceResponse.data)

          return {
            ...serviceResponse.data.service,
            amount: item.amount,
            type: 'service',
          }
        }
      })

      const items: any[] = await Promise.all(itemsPromises)
      console.log('InvoiceSubscription - mapped items:', items)

      // Guardar el porcentaje de descuento si viene en la URL
      // El cálculo del valor absoluto se hará en Sells.tsx basado en el subtotal real
      if (discount) {
        const discountPercentage = parseFloat(discount)
        console.log('InvoiceSubscription - Pasando porcentaje de descuento:', discountPercentage, '%')

        if (!isNaN(discountPercentage)) {
          // Pasamos el porcentaje, no el valor absoluto
          // Sells.tsx calculará el valor absoluto basado en el subtotal que él calcula
          setDiscountFromUrl(discountPercentage)
        }
      }

      setSubscriptionData({
        client,
        subscription,
        items,
      })

      setIsLoading(false)
    } catch (error: any) {
      console.error('InvoiceSubscription - Error fetching subscription data:', error)
      console.error('InvoiceSubscription - Error response:', error?.response?.data)
      setNotFound(true)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    onGetSubscriptionData()

    setTimeout(() => {
      setRender(true)
    }, 1000)
  }, [])

  if (!render || isLoading) return <Loading />

  if (notFound) {
    return (
      <div className="flex flex-col items-center justify-center h-[70vh]">
        <h1 className="text-2xl font-bold">Suscripción no encontrada</h1>
        <p className="text-sm text-gray-500">
          La suscripción que estás buscando no existe o no tiene datos válidos.
        </p>
      </div>
    )
  }

  if (subscriptionData && subscriptionData.items.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-[70vh]">
        <h1 className="text-2xl font-bold">Suscripción sin artículos</h1>
        <p className="text-sm text-gray-500">
          La suscripción no tiene artículos o servicios para facturar.
        </p>
      </div>
    )
  }

  return (
    <Sells
      setHeaderActions={() => {}}
      clientProp={{
        id: subscriptionData?.client.id || 0,
        name: subscriptionData?.client.name || '',
        documentType: subscriptionData?.client.documentType || '',
        document: subscriptionData?.client.document || '',
      } as any}
      itemsProp={subscriptionData?.items?.map((x: any) => {
        console.log('InvoiceSubscription - mapping item for Sells:', x)
        const mappedItem = {
          amount: x.amount?.toString() || '1',
          barcode: x.barcode || '',
          brand: x.brand || '',
          category: {
            id: x?.category?.id?.toString() || '',
            name: x?.category?.name || '',
          },
          cost: x?.cost?.toString() || '',
          currency: {
            id: x?.currency?.id?.toString() || '',
          },
          description: x.description || '',
          id: x?.id?.toString() || '',
          inCatalog: x.inCatalog || false,
          ivaType: x.ivaType || 'GENERAL',
          name: x.name || '',
          price: x?.price?.toString() || '',
          quantity: x?.amount?.toString() || '1',
          sku: x.sku || '',
          type: x.type,  // ✅ CRÍTICO: usar 'type' directamente (ej: "MERCHANDISE", "service")
          unit: {
            id: x?.unit?.id?.toString() || '',
          },
        }
        console.log('InvoiceSubscription - mapped item result:', mappedItem)
        return mappedItem
      })}
      payment_methods={[]}
      statusProp={undefined}
      onGoBack={() => {}}
      discountProp={discountFromUrl}
    />
  )
}

export default InvoiceSubscription
